export const components = {
  '* The time is up, send another code to continue':
    '* O tempo acabou, envie outro código para poder continuar.',
  'All rights reserved to Vialaser Servicos Esteticos S.A - {{year}}':
    'Todos os direitos reservados a Vialaser Serviços Estéticos S.A - {{year}}',
  'Almost there!': 'Quase lá!',
  'App menu link': 'Aplicativo',
  'App at appstore': 'App na appstore',
  'App at google play': 'App na google play',
  'As soon as three friends, that dont know Vialaser yet, register themselves, you will get an <1>{{value}} exclusive coupon</1> at your email for the purchase of any package':
    'Assim que três amigos, que ainda não conheçam a Vialaser, se cadastrarem, você receberá no seu e-mail um <1>cupom exclusivo de {{value}}</1> para a compra de qualquer pacote.',
  'A true friend is the one that refer <1>{{value}} in discounts</1> to you and your friends <3>Enjoy!</3>':
    'Amigo de verdade é quem indica. <1>{{value}} de desconto</1> para você e seus amigos. <3>Aproveite!</3>',
  'At Vialaser your recommendation means a looooot! <1>Up to {{value}} in discounts</1> of your installments <3>Enjoy!</3>':
    'Na Vialaser a sua indicação vale muuuuuuuito! <1>Até {{value}} de desconto</1> nas suas parcelas. <3>Aproveite!</3>',
  'Be franchised': 'Seja franqueado',
  'Below you may leave a comment of your choice about the session':
    'Abaixo você pode fazer algum comentário de sua escolha sobre a sessão.',
  Blog: 'Blog',
  'Buy now': 'Comprar agora',
  Cart: 'Carrinho',
  'Choose other sending option': 'Escolher outra opção de envio',
  'Citizen Service': 'Central de Atendimento',
  'Click here to sign in!': 'Clique aqui para se cadastrar!',
  Close: 'Fechar',
  Combos: 'Combos',
  Contact: 'Contato',
  Contracts: 'Contratos',
  'Copy link': 'Copiar link',
  'Coupon valid only for purchases above {{value}}':
    '* Cupom válido para compras acima de {{value}}',
  'Credit card': 'Cartão de crédito',
  'Create your account': 'Crie sua conta',
  'Customer area': 'Área do cliente',
  'CUSTOMER WEEK ⚡ BUY A COMBO AND GET A FREE AREA!':
    'SEMANA DO CONSUMIDOR ⚡ COMPRE UM COMBO E GANHE ÁREA GRÁTIS!',
  Day_one: 'Dia',
  Day_other: 'Dias',
  "Don't have a Vialaser account yet?": 'Ainda não possui sua conta Vialaser?',
  '<0>Double discount</0> by referring three friends, you and them both get a super discount 🥰':
    '<0>Desconto em dobro:</0> ao indicar três amigos, você ganha um super desconto e eles também. 🥰',
  'E-mail': 'E-mail',
  Enter: 'Entrar',
  'Evaluate session': 'Avaliar sessão',
  Exit: 'Sair',
  'Find a clinic': 'Encontre uma clínica',
  'Follow Vialaser at our Social Networks':
    'Siga a Vialaser nas nossas Redes Sociais:',
  'From 1 to 10 tell us what did you think about your {{regions}} session with the applicator {{applicator}}':
    'De 1 a 10 nos diga oque você achou da sua sessão de {{regions}} com a aplicadora {{applicator}}.',
  'Give your feedback!': 'Dê o seu feedback!',
  'Hello,<1></1>{{name}}!': 'Olá,<1></1>{{name}}!',
  Home: 'Início',
  Hour_one: 'Hora',
  Hour_other: 'Horas',
  'I wanna know how it works': 'Quero saber como funciona',
  "I'm interested in knowing more about laser hair removal promotions":
    'Tenho interesse em saber mais sobre promoções de depilação a laser',
  'Leave feedback on Google': 'Deixar avaliação no Google',
  'Link successfully copied!': 'Link copiado com sucesso!',
  'Loading terms': 'Carregando termos...',
  Minutes: 'Minutos',
  'My data': 'Meus dados',
  'My recommendations': 'Minhas indicações',
  Next: 'Próximo',
  optional: 'opcional',
  "Our friendship is worth millions and in Vialaser it's worth a discount! 😍%0aWin a {{discount}} discount on the purchase of a hair removal package at Vialaser by subscribing with my link, but remember, this cupon is only valid for purchases up to {{minValue}} %0a%0a{{link}}":
    'A nossa amizade é de milhões e na Vialaser ela vale desconto! 😍%0aGaranta {{discount}} de desconto na compra de um pacote de depilação a laser na Vialaser se inscrevendo no meu link, mas lembre-se, esse cupom é válido para compras acima de {{minValue}}. %0a%0a{{link}}',
  'Our technology': 'Nossa tecnologia',
  Packages: 'Pacotes',
  'Payment methods': 'Formas de pagamento',
  'Privacy policies': 'Políticas de privacidade',
  'Please, contact an attendant to solve the issue':
    'Por favor, contate uma atendente para resolver o problema.',
  'Recommend and Win!': 'Indique e Ganhe!',
  'Recommend your friends and gain priceless discounts':
    'Indique seus amigos e ganhe descontos imperdíveis',
  'Recurrent card': 'Cartão recorrente',
  'Sales center': 'Central de Vendas',
  'Schedule session': 'Agendar sessão',
  Schedulings: 'Agendamentos',
  'Search packages at Vialaser': 'Buscar pacotes na Vialaser',
  Seconds: 'Segundos',
  'Send again': 'Enviar novamente',
  'Send again in {{count}}s': 'Enviar novamente em {{count}}s',
  Sessions: 'Sessões',
  'Share your link via Whatsapp': 'Compartilhe seu link pelo WhatsApp',
  'Sign up': 'Fazer login',
  'Since you like our services, how about leaving a feedback on Google?':
    'Já que gostou dos nossos serviços, que tal nos avaliar no Google?',
  'Something unexpected happened!': 'Aconteceu algo inesperado!',
  'Terms of use': 'Termos de uso',
  'Thanks for the evaluation!': 'Agradecemos a avaliação!',
  'The code is valid only for {{count}} minutes_one':
    'O código é válido apenas por {{count}} minuto.',
  'The code is valid only for {{count}} minutes_other':
    'O código é válido apenas por {{count}} minutos.',
  'The link could not be copied Please try again!':
    'Não foi possível copiar o link. Tente novamente!',
  'The link could not be shared Please try again!':
    'Não foi possível compartilhar o link. Tente novamente!',
  'There is no channel available for sending you the code':
    'Não há nenhum canal disponível para enviar o código de validação para você.',
  'There was an error finding the accession terms':
    'Houve um erro ao buscar os termos de adesão.',
  'Time left': 'Falta apenas:',
  'Type the last code you received in your email {{email}}':
    'Digite o último código que chegou via e-mail para {{email}}.',
  'Type the last code you received in your whatsapp with final number of {{phone}}':
    'Digite o último código que chegou via WhatsApp para o número de final {{phone}}.',
  'Type the last code you received in your phone with final number of {{phone}}':
    'Digite o último código que chegou via SMS para o número de final {{phone}}.',
  'Validate code': 'Validar código',
  Validation: 'Validação',
  'Verification code': 'Código de verificação',
  'Vialaser - Hair removal clinic with exclusive technology':
    'Vialaser - Clínica de depilação a Laser com tecnologia exclusiva',
  Visitor: 'Visitante',
  'With 1 being a terrible application and 10 an excellent one':
    'Sendo 1 uma aplicação péssima e 10 excelente.',
  'Where to find': 'Onde encontrar',
  'Who we are': 'Quem somos',
  'Work with us': 'Trabalhe conosco',
  'You can send your personalized link to as many friends as you want <1>The more you indicate, the easier it is to win</1> For each friend who purchases a package over {{minimumBudgetValue}} you receive a <5>discount of {{value}} on your next installment</5> Your referrals <7>also receive a {{discount}} discount</7> to keep their waxing up to date':
    'Você pode enviar o seu link personalizado para quantos amigos quiser. <1>Quanto mais indicar, mais fácil de ganhar.</1> A cada amigo que adquirir um pacote acima de {{minimumBudgetValue}} você ganha um <5>desconto de {{value}} na sua próxima parcela.</5> Seus indicados <7>também ganham {{discount}} de desconto</7> para deixar a depilação em dia.',
  'Your comment here': 'Seu comentário aqui...',
  'Your feedback was registered Thanks!':
    'Seu feedback foi registrado. Obrigado!',

  'Ops something went wrong!': 'Ops... algo deu errado!',
  'Something did not worked as expected Try again realoding the page or go to the home':
    'Alguma coisa não funcionou como esperado. Tente recarregar a página ou volte para o início.',
  'Refresh page': 'Recarregar página',
  'Go to home': 'Voltar para o início',

  'To update your contact data <1>click here</1>':
    'Para alterar seus dados de contato <1>clique aqui.</1>',
  Confirm: 'Confirmar',
  Cancel: 'Cancelar',
  "I've read and understood": 'Li e entendi',
  'Absence and cancellation warning': 'Aviso de faltas e cancelamentos',
  'There was an error loading this warning. Please try again.':
    'Houve um erro ao carregar este aviso. Tente novamente.',
  'There was an error confirming this warning. Please try again.':
    'Houve um erro ao confirmar este aviso. Tente novamente.',

  hour_one: 'hora',
  hour_other: 'horas',
  minute_one: 'minuto',
  minute_other: 'minutos',
  second_one: 'segundo',
  second_other: 'segundos',
};
